import { parseLabel } from 'src/apps/web-sdks/pages/tests/components/shared/helpers';
import { IWebSdkTest } from 'src/apps/web-sdks/types/WebSdkDashboardServiceTypes';
import {
	ENVIRONMENT_FILTER_NAME,
	FLOW_FILTER_NAME
} from 'src/common/helpers/GQLRequestsHelper/labelFilters';

import {
	createCustomFieldRemoveChange,
	ENVIRONMENT_REMOVE_CHANGE,
	FLOW_REMOVE_CHANGE
} from '../builders/PayloadBuilder';
import { Change } from '../types/PayloadTypes';

type LabelHandler = (
	labelValueLowercase: string,
	labelValueOriginal: string,
	row: IWebSdkTest,
	parsedKey: string
) => Change;

const handleEnvironmentLabel: LabelHandler = (
	labelValueLowercase,
	labelValueOriginal,
	row,
	parsedKey
) => {
	const environments = row.environments ?? [];
	const matchingEnv = environments.find(
		(env) => env.trim().toLowerCase() === labelValueLowercase.trim()
	);
	if (matchingEnv) {
		return ENVIRONMENT_REMOVE_CHANGE;
	}
	// If not in environments, remove from custom fields
	return createCustomFieldRemoveChange(parsedKey, labelValueOriginal);
};

const handleFlowLabel: LabelHandler = (labelValueLowercase, labelValueOriginal, row, parsedKey) => {
	const flows = row.flows ?? [];
	const matchingFlow = flows.find(
		(flow) => flow.trim().toLowerCase() === labelValueLowercase.trim()
	);
	if (matchingFlow) {
		return FLOW_REMOVE_CHANGE;
	}
	// If not in flows, remove from custom fields
	return createCustomFieldRemoveChange(parsedKey, labelValueOriginal);
};

const LABEL_HANDLERS: Record<string, LabelHandler> = {
	[ENVIRONMENT_FILTER_NAME.toLowerCase()]: handleEnvironmentLabel,
	[FLOW_FILTER_NAME.toLowerCase()]: handleFlowLabel
} as const;

export const createRemovalChangeForLabel = (
	labelString: string,
	row: IWebSdkTest
): Change | null => {
	const parsed = parseLabel(labelString);
	if (!parsed?.key) {
		return null;
	}

	const labelKey = parsed.key.toLowerCase();
	const labelValue = parsed.value.toLowerCase();

	const handler = LABEL_HANDLERS[labelKey];
	if (handler) {
		return handler(labelValue, parsed.value, row, parsed.key);
	}

	// For all other labels, remove from custom fields
	return createCustomFieldRemoveChange(parsed.key, parsed.value);
};
